if (typeof CookieControlConsent !== 'undefined') {

  var _ga_api_key = 'UA-98851848-1';

  new CookieControlConsent(
    'performance',
    [
      '_ga',
      '_gid',
      '_gat',
      '__utma',
      '__utmt',
      '__utmb',
      '__utmc',
      '__utmz',
      '__utmv',
      'Collect'
    ],
    function(e) {

      var hostname = window.location.host;
      if (hostname === 'amz.6-2.co.uk' || hostname === 'localhost') {
        console.warn('Host is local or staging, Analytics Tracking disabled');
        return;
      }

      // Enable Google Analytics Cookie
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', _ga_api_key, 'auto');
      ga('send', 'pageview');

    },
    function(e) {

      // Disable Google Analytics Cookie
      window['ga-disable-'+_ga_api_key] = true;

    }
  );

  new CookieControlConsent(
    'functionality',
    [],
    function(e) {},
    function(e) {}
  );

  new CookieControlConsent(
    'targeting-or-advertising',
    [],
    function(e) {},
    function(e) {}
  );

}
